/* #####  Constant URLs for different route  ##### */

const PageURL = {
  BASE: "/",
  SIGN_UP: "/user/register",
  FORGOT_PASSWORD: "/user/forgot-password",
  RESET_PASSWORD: "/password/reset/:token",
  OTP_VERIFICATION: "/user/forgot-password/otp/verify",
  COUNTRYDEFAULT: "/dashboard",
  PROJECT_DETAILS: "/dashboard/project-details",
  PROJECT_ANALYTICS: "/dashboard/project-analytics",
  INDIA_GEN_SUMMARY: "/dashboard/generationsummary",
  INDIA_PROJ_OVERVIEW: "/dashboard/projectoverview",
  INDIA_PRES_MODEL_Loss_Flow: "/dashboard/prescriptivemodel/loss-flow",
  INDIA_PRES_MODEL_Fault_Tree: "/dashboard/prescriptivemodel/fault-tree",
  INDIA_DIAGONISTIC: "/dashboard/diagonistic",
  INDIA_DIAGONISTIC_DETAILED: "/dashboard/diagonistic/detailed",
  INDIA_LOSS_FLOW: "/dashboard/diagonistic/lossflow",
  INDIA_INVERTER_EFFICIENCY: "/dashboard/diagonistic/inverter-efficiency",
  INDIA_INVERTER_DEVIATION: "/dashboard/diagonistic/inverter-deviation",
  INDIA_INVERTER_HEATMAP_DIAGRAM:
    "/dashboard/diagonistic/inverter/heatmap-diagram",
  SCBSMBSTRING_LOSS: "/dashboard/projectdetail/scbsmbstring-loss",
  ADMIN_DASHBOARD: "/dashboard/admin",
  NOTIFICATION: "/dashboard/notifications",

  GENERATION_SUMMARY_PREDICTIVE: "/dashboard/generationsummary/forecasting",
  DIAGONISTIC_DETAILED_PREDICTIVE: "/dashboard/diagonistic/detailed/forecasting",


    // Predictive Analytics Section
  PREDICTIVE_DROP_IN_PR: "/dashboard/predictive/drop-in-pr",
  PREDICTIVE_DC_STRING_IMBALANCE: "/dashboard/predictive/dc-string-imbalance",
  PREDICTIVE_INVERTER_AVAILABILITY: "/dashboard/predictive/inverter-availability",
  PREDICTIVE_LV_AC_CABLE_LOSS: "/dashboard/predictive/lv-ac-cable-loss",
  PREDICTIVE_MODULE_DEGRADATION: "/dashboard/predictive/module-degradation",
  PREDICTIVE_MODULE_HOTSPOT: "/dashboard/predictive/module-hotspot",
  PREDICTIVE_MOUNTING_STRUCTURE: "/dashboard/predictive/mounting-structure",
  PREDICTIVE_CONNECTOR_HEATING: "/dashboard/predictive/connector-heating",
  PREDICTIVE_CABLE_INSULATION: "/dashboard/predictive/cable-insulation",
  PREDICTIVE_TRANSFORMER_TEMPERATURE: "/dashboard/predictive/transformer-temperature",

  // Forecasting Section
  FORECASTING_SOILING_LOSS: "/dashboard/forecasting/soiling-loss",

  PREDICTIVE_SCBSMBSTRING_LOSS: "/dashboard/predictive/scbsmbstring-loss",

    PREDICTIVE_INVERTER_HEATMAP_DIAGRAM:
    "/dashboard/predictive/inverter/heatmap-diagram",
};

export default PageURL;
